module.exports = __webpack_public_path__ + "static/media/marginMerge.38d43b06.gif";